// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2_lV0","loaderOuter":"PageOverlayLoader_loaderOuter__JbSpY"};